import { useEffect } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

declare global {
  interface Window {
    adsbygoogle?: Record<string, unknown>[];
  }
}

interface AdBannerProps {
  adSlot: string;
}

const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

export default function AdBanner({ adSlot }: AdBannerProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (isLocal) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Ad error:", e);
    }
  }, []);

  if (isLocal) return null;

  return (
    <Box
      id={`ad-banner-${adSlot}`}
      sx={{
        width: "100%",
        maxWidth: 960,
        mx: "auto",
        my: isMobile ? "8px" : 2,
        backgroundColor: "rgba(0,0,0,0.1)",
        borderRadius: 1,
        minHeight: isMobile ? 140 : 250,
      }}
    >
      <ins
        key={adSlot}
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }}
        data-ad-client="ca-pub-2445506326822662"
        data-ad-slot={adSlot}
        data-ad-format="rectangle"
        data-ad-layout="in-article"
      />
    </Box>
  );
}
